module.exports = function getResource(label, vars = []) {
    let resources = {
        //Main component
        nextButtonLabel: 'Suivant',
        previousButtonLabel: 'Précédent',

        //GetStarted component
        welcomeMessage: 'Bienvenue chez',
        getStartedButtonLabel: 'Démarrer',

        //Error component
        playSubscriptionErrorMessage: 'Cette page est exclusive aux abonnés PLAY! de Sephora.',
        playJoinMessage: 'Pour vous inscrire, veuillez visiter',
        connectionErrorMessage: 'Désolé, il semble y avoir un problème de connexion.',
        tryAgainMessage: 'Veuillez essayer de nouveau.',

        //Constants
        skinType: 'Quel est votre *type de peau?*',
        skinTone: 'Quel est le *ton de votre peau?*',
        skincare: 'Quelles sont vos *préoccupations en matière de soins de la peau?*',
        hairColor: 'Quelle est la *couleur de vos cheveux?*',
        hairDescrible: 'Comment décririez-vous vos *cheveux?*',
        hairConcerns: 'Quelles sont vos *préoccupations en lien avec les cheveux?*',
        eyeColor: 'Quelle est la *couleur de vos yeux?*',
        beautyHabitsAgreement: 'Vous trouverez ci-dessous une liste d’énoncés pouvant correspondre à vos attitudes à l’égard de la beauté.',
        skincareDirection: 'Choisissez toutes les réponses qui s’appliquent.',
        hairDescribleDirection: 'Choisissez toutes les réponses qui s’appliquent.',
        hairConcernsDirection: 'Choisissez toutes les réponses qui s’appliquent.',
        beautyHabitsAgreementDirection: 'Veuillez nous dire à quel point vous êtes en accord ou en désaccord avec ces énoncés.',
        skinCategory: 'Peau',
        hairCategory: 'Cheveux',
        eyesCategory: 'Yeux',
        preferencesCategory: 'Préférences'
    };

    return resources[label];
};
